import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import * as specialistActions from '../../actions/specialistActions';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	Modal,


} from 'react-bootstrap';
// import classNames from 'classnames';
// import validator from './../common/validator.js';
const autoBind = require('auto-bind');

const styleP = { fontSize: 14, fontWeight: 600, marginRight: 2 };
const styleS = { fontSize: 14, fontWeight: 400 };
const stylephone = { fontSize: 14, fontWeight: 400 };

class ClinicDetail extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			mondayMornStartHrs: '8',
			mondayMornStartMin: '00',
			mondayMornEndHrs: '10',
			mondayMornEndMin: '00',

			mondayEvenStartHrs: '17',
			mondayEvenStartMin: '00',
			mondayEvenEndHrs: '22',
			mondayEvenEndMin: '00',

			tuesdayMornStartHrs: '8',
			tuesdayMornStartMin: '00',
			tuesdayMornEndHrs: '10',
			tuesdayMornEndMin: '00',

			tuesdayEvenStartHrs: '17',
			tuesdayEvenStartMin: '00',
			tuesdayEvenEndHrs: '22',
			tuesdayEvenEndMin: '00',

			wednesdayMornStartHrs: '8',
			wednesdayMornStartMin: '00',
			wednesdayMornEndHrs: '10',
			wednesdayMornEndMin: '00',

			wednesdayEvenStartHrs: '17',
			wednesdayEvenStartMin: '00',
			wednesdayEvenEndHrs: '22',
			wednesdayEvenEndMin: '00',

			thursdayMornStartHrs: '8',
			thursdayMornStartMin: '00',
			thursdayMornEndHrs: '10',
			thursdayMornEndMin: '00',

			thursdayEvenStartHrs: '17',
			thursdayEvenStartMin: '00',
			thursdayEvenEndHrs: '22',
			thursdayEvenEndMin: '00',

			fridayMornStartHrs: '8',
			fridayMornStartMin: '00',
			fridayMornEndHrs: '10',
			fridayMornEndMin: '00',

			fridayEvenStartHrs: '17',
			fridayEvenStartMin: '00',
			fridayEvenEndHrs: '22',
			fridayEvenEndMin: '00',

			saturdayMornStartHrs: '8',
			saturdayMornStartMin: '00',
			saturdayMornEndHrs: '10',
			saturdayMornEndMin: '00',

			saturdayEvenStartHrs: '17',
			saturdayEvenStartMin: '00',
			saturdayEvenEndHrs: '22',
			saturdayEvenEndMin: '00',

			sundayMornStartHrs: '8',
			sundayMornStartMin: '00',
			sundayMornEndHrs: '10',
			sundayMornEndMin: '00',

			sundayEvenStartHrs: '17',
			sundayEvenStartMin: '00',
			sundayEvenEndHrs: '22',
			sundayEvenEndMin: '00',

		};

	}
	componentWillMount() {
		var state = this.state;

		if (this.props.viewClinicInfo.monday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.mondayMornInTime) {
				var time = (this.props.viewClinicInfo.mondayMornInTime).split(':');
				if (time && time.length > 0) {
					state.mondayMornStartHrs = time[0];
					state.mondayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.mondayMornOutTime) {
				var time = (this.props.viewClinicInfo.mondayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.mondayMornEndHrs = time[0];
					state.mondayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.mondayEvenInTime) {
				var time = (this.props.viewClinicInfo.mondayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.mondayEvenStartHrs = time[0];
					state.mondayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.mondayEvenOutTime) {
				var time = (this.props.viewClinicInfo.mondayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.mondayEvenEndHrs = time[0];
					state.mondayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.tuesday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.tuesdayMornInTime) {
				var time = (this.props.viewClinicInfo.tuesdayMornInTime).split(':');
				if (time && time.length > 0) {
					state.tuesdayMornStartHrs = time[0];
					state.tuesdayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.tuesdayMornOutTime) {
				var time = (this.props.viewClinicInfo.tuesdayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.tuesdayMornEndHrs = time[0];
					state.tuesdayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.tuesdayEvenInTime) {
				var time = (this.props.viewClinicInfo.tuesdayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.tuesdayEvenStartHrs = time[0];
					state.tuesdayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.tuesdayEvenOutTime) {
				var time = (this.props.viewClinicInfo.tuesdayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.tuesdayEvenEndHrs = time[0];
					state.tuesdayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.wednesday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.wednesdayMornInTime) {
				var time = (this.props.viewClinicInfo.wednesdayMornInTime).split(':');
				if (time && time.length > 0) {
					state.wednesdayMornStartHrs = time[0];
					state.wednesdayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.wednesdayMornOutTime) {
				var time = (this.props.viewClinicInfo.wednesdayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.wednesdayMornEndHrs = time[0];
					state.wednesdayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.wednesdayEvenInTime) {
				var time = (this.props.viewClinicInfo.wednesdayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.wednesdayEvenStartHrs = time[0];
					state.wednesdayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.wednesdayEvenOutTime) {
				var time = (this.props.viewClinicInfo.wednesdayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.wednesdayEvenEndHrs = time[0];
					state.wednesdayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.thursday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.thursdayMornInTime) {
				var time = (this.props.viewClinicInfo.thursdayMornInTime).split(':');
				if (time && time.length > 0) {
					state.thursdayMornStartHrs = time[0];
					state.thursdayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.thursdayMornOutTime) {
				var time = (this.props.viewClinicInfo.thursdayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.thursdayMornEndHrs = time[0];
					state.thursdayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.thursdayEvenInTime) {
				var time = (this.props.viewClinicInfo.thursdayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.thursdayEvenStartHrs = time[0];
					state.thursdayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.thursdayEvenOutTime) {
				var time = (this.props.viewClinicInfo.thursdayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.thursdayEvenEndHrs = time[0];
					state.thursdayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.friday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.fridayMornInTime) {
				var time = (this.props.viewClinicInfo.fridayMornInTime).split(':');
				if (time && time.length > 0) {
					state.fridayMornStartHrs = time[0];
					state.fridayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.fridayMornOutTime) {
				var time = (this.props.viewClinicInfo.fridayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.fridayMornEndHrs = time[0];
					state.fridayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.fridayEvenInTime) {
				var time = (this.props.viewClinicInfo.fridayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.fridayEvenStartHrs = time[0];
					state.fridayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.fridayEvenOutTime) {
				var time = (this.props.viewClinicInfo.fridayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.fridayEvenEndHrs = time[0];
					state.fridayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.saturday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.saturdayMornInTime) {
				var time = (this.props.viewClinicInfo.saturdayMornInTime).split(':');
				if (time && time.length > 0) {
					state.saturdayMornStartHrs = time[0];
					state.saturdayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.saturdayMornOutTime) {
				var time = (this.props.viewClinicInfo.saturdayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.saturdayMornEndHrs = time[0];
					state.saturdayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.saturdayEvenInTime) {
				var time = (this.props.viewClinicInfo.saturdayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.saturdayEvenStartHrs = time[0];
					state.saturdayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.saturdayEvenOutTime) {
				var time = (this.props.viewClinicInfo.saturdayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.saturdayEvenEndHrs = time[0];
					state.saturdayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
		if (this.props.viewClinicInfo.sunday == true) {
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.sundayMornInTime) {
				var time = (this.props.viewClinicInfo.sundayMornInTime).split(':');
				if (time && time.length > 0) {
					state.sundayMornStartHrs = time[0];
					state.sundayMornStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.sundayMornOutTime) {
				var time = (this.props.viewClinicInfo.sundayMornOutTime).split(':');
				if (time && time.length > 0) {
					state.sundayMornEndHrs = time[0];
					state.sundayMornEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.sundayEvenInTime) {
				var time = (this.props.viewClinicInfo.sundayEvenInTime).split(':');
				if (time && time.length > 0) {
					state.sundayEvenStartHrs = time[0];
					state.sundayEvenStartMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
			if (this.props.viewClinicInfo && this.props.viewClinicInfo.sundayEvenOutTime) {
				var time = (this.props.viewClinicInfo.sundayEvenOutTime).split(':');
				if (time && time.length > 0) {
					state.sundayEvenEndHrs = time[0];
					state.sundayEvenEndMin = (time[1] == '0') ? '00' : time[1];
					this.setState(state);
				}
			}
		}
	}


	render() {
		
		return (
			<Modal show={this.props.show} size="modal-sm" onHide={this.props.hideClinicModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideClinicModal} /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form clinicSmart" id="loginForm"  >
						<div className="row">

							<div className="col-lg-12">
								<h2> {this.props.viewClinicInfo.clinicName}</h2>
							</div>
							<div className="col-lg-12">
								<div className="text-capitalize" style={styleS}><i className="fa fa-map-marker"></i> <div className="clinicAdd">{this.props.viewClinicInfo.addressLineOne}, {this.props.viewClinicInfo.city}, {this.props.viewClinicInfo.zipCode}, {this.props.viewClinicInfo.state}</div></div>
							</div>	</div>
						<br />

						<div className="myFeedbacks">
							<div className="row">

								<div className="col-lg-6">
									<p className="phoneInfo" style={stylephone}><i className="fa fa-mobile"></i> <span className="clinePhone" > {this.props.viewClinicInfo.phoneCode2} - {this.props.viewClinicInfo.telephoneNo ? this.props.viewClinicInfo.telephoneNo : '  --'}</span>
									</p>
									<p className="phoneInfo mobileIcon" style={stylephone}><i className="fa fa-phone"></i><span className="clinePhone" >{this.props.viewClinicInfo.phoneCode1} - {this.props.viewClinicInfo.mobileNo ? this.props.viewClinicInfo.mobileNo : '--'}</span></p>
								</div>
								<div className="col-lg-6">
									<p style={styleP}><i><img src={require('../../images/img/consultation_fees_icons.png')} alt="" /></i> Consultation fees {this.props.viewClinicInfo.currencySymbol} {this.props.viewClinicInfo.fee}</p>

								</div>
							</div>
						</div>

						<br />
						<div className="row">
							<div className="col-lg-6">
								<div className="consultationDay">Consultation Day(s): </div>
								<div className="consultationDayName">
									{this.props.viewClinicInfo.monday == true ? ' Monday ' : ''}
									{this.props.viewClinicInfo.tuesday == true ? ' Tuesday ' : ''}
									{this.props.viewClinicInfo.wednesday == true ? ' Wednesday ' : ''}
									{this.props.viewClinicInfo.thursday == true ? ' Thursday ' : ''}
									{this.props.viewClinicInfo.friday == true ? ' Friday ' : ''}
									{this.props.viewClinicInfo.saturday == true ? ' Saturday ' : ''}
									{this.props.viewClinicInfo.sunday == true ? ' Sunday ' : ''}
								</div>		</div>
						</div><br />
						<div className="row"><div className="col-lg-12">
							<div className="consultationHrs ">Consultation Hours:</div>
							<div className="table-responsive clinicadd-text ">
								<table cellSpacing="0" cellPadding="0" className="consultationHr" width="100%">
									<tbody>
										<tr>
											<td width="25%">&nbsp;</td>
											<td width="45%"><img className="clinicaddImg" src={require('../../images/img/sun_icon.png')} /></td>
											<td width="30%"><img className="clinicaddImg" src={require('../../images/img/moon_icon.png')} /></td>
										</tr>
										<tr>

											<td>MON</td>
											{this.props.viewClinicInfo.monday && !this.props.viewClinicInfo.mondayMorning == true ? <td><table><tr><td>{this.state.mondayMornStartHrs}:{this.state.mondayMornStartMin} </td><td>-</td> <td>{this.state.mondayMornEndHrs}:{this.state.mondayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.monday && !this.props.viewClinicInfo.mondayEvening == true ? <td><table><tr><td>{this.state.mondayEvenStartHrs}:{this.state.mondayEvenStartMin} </td><td>-</td> <td>{this.state.mondayEvenEndHrs}:{this.state.mondayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>TUE</td>
											{this.props.viewClinicInfo.tuesday && !this.props.viewClinicInfo.tuesdayMorning == true ? <td><table><tr><td>{this.state.tuesdayMornStartHrs}:{this.state.tuesdayMornStartMin} </td><td>-</td> <td>{this.state.tuesdayMornEndHrs}:{this.state.tuesdayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.tuesday && !this.props.viewClinicInfo.tuesdayEvening == true ? <td><table><tr><td>{this.state.tuesdayEvenStartHrs}:{this.state.tuesdayEvenStartMin} </td><td>-</td> <td>{this.state.tuesdayEvenEndHrs}:{this.state.tuesdayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>WED</td>
											{this.props.viewClinicInfo.wednesday && !this.props.viewClinicInfo.wednesdayMorning == true ? <td><table><tr><td>{this.state.wednesdayMornStartHrs}:{this.state.wednesdayMornStartMin} </td><td>-</td> <td>{this.state.wednesdayMornEndHrs}:{this.state.wednesdayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.wednesday && !this.props.viewClinicInfo.wednesdayEvening == true ? <td><table><tr><td>{this.state.wednesdayEvenStartHrs}:{this.state.wednesdayEvenStartMin} </td><td>-</td> <td>{this.state.wednesdayEvenEndHrs}:{this.state.wednesdayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>THU</td>
											{this.props.viewClinicInfo.thursday && !this.props.viewClinicInfo.thursdayMorning == true ? <td><table><tr><td>{this.state.thursdayMornStartHrs}:{this.state.thursdayMornStartMin} </td><td>-</td> <td>{this.state.thursdayMornEndHrs}:{this.state.thursdayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.thursday && !this.props.viewClinicInfo.thursdayEvening == true ? <td><table><tr><td>{this.state.thursdayEvenStartHrs}:{this.state.thursdayEvenStartMin} </td><td>-</td> <td>{this.state.thursdayEvenEndHrs}:{this.state.thursdayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>FRI</td>
											{this.props.viewClinicInfo.friday && !this.props.viewClinicInfo.fridayMorning == true ? <td><table><tr><td>{this.state.fridayMornStartHrs}:{this.state.fridayMornStartMin} </td><td>-</td> <td>{this.state.fridayMornEndHrs}:{this.state.fridayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.friday && !this.props.viewClinicInfo.fridayEvening == true ? <td><table><tr><td>{this.state.fridayEvenStartHrs}:{this.state.fridayEvenStartMin} </td><td>-</td> <td>{this.state.fridayEvenEndHrs}:{this.state.fridayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>SAT</td>
											{this.props.viewClinicInfo.saturday && !this.props.viewClinicInfo.saturdayMorning == true ? <td><table><tr><td>{this.state.saturdayMornStartHrs}:{this.state.saturdayMornStartMin} </td><td>-</td> <td>{this.state.saturdayMornEndHrs}:{this.state.saturdayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.saturday && !this.props.viewClinicInfo.saturdayEvening == true ? <td><table><tr><td>{this.state.saturdayEvenStartHrs}:{this.state.saturdayEvenStartMin} </td><td>-</td> <td>{this.state.saturdayEvenEndHrs}:{this.state.saturdayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
										<tr>
											<td>SUN</td>
											{this.props.viewClinicInfo.sunday && !this.props.viewClinicInfo.sundayMorning == true ? <td><table><tr><td>{this.state.sundayMornStartHrs}:{this.state.sundayMornStartMin} </td><td>-</td> <td>{this.state.sundayMornEndHrs}:{this.state.sundayMornEndMin}</td></tr> </table></td> : <td>--</td>}
											{this.props.viewClinicInfo.sunday && !this.props.viewClinicInfo.sundayEvening == true ? <td><table><tr><td>{this.state.sundayEvenStartHrs}:{this.state.sundayEvenStartMin} </td><td>-</td> <td>{this.state.sundayEvenEndHrs}:{this.state.sundayEvenEndMin}</td></tr> </table></td> : <td>--</td>}
										</tr>
									</tbody>
								</table>
							</div></div></div>

						{/* {this.props.viewClinicInfo.monday == true ? <div>
							<div className="row">
								<p style={styleP}>Monday Morning Time: </p>
								<p style={styleS}>{this.state.mondayMornStartHrs}:{this.state.mondayMornStartMin} to {this.state.mondayMornEndHrs}:{this.state.mondayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Monday Evening Time:</p>
								<p style={styleS}>{this.state.mondayEvenStartHrs}:{this.state.mondayEvenStartMin} to {this.state.mondayEvenEndHrs}:{this.state.mondayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.tuesday == true ? <div>
							<div className="row">
								<p style={styleP}>Tuesday Morning Time: </p>
								<p style={styleS}>{this.state.tuesdayMornStartHrs}:{this.state.tuesdayMornStartMin} to {this.state.tuesdayMornEndHrs}:{this.state.tuesdayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Tuesday Evening Time:</p>
								<p style={styleS}>{this.state.tuesdayEvenStartHrs}:{this.state.tuesdayEvenStartMin} to {this.state.tuesdayEvenEndHrs}:{this.state.tuesdayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.wednesday == true ? <div>
							<div className="row">
								<p style={styleP}>Wednesday Morning Time: </p>
								<p style={styleS}>{this.state.wednesdayMornStartHrs}:{this.state.wednesdayMornStartMin} to {this.state.wednesdayMornEndHrs}:{this.state.wednesdayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Wednesday Evening Time:</p>
								<p style={styleS}>{this.state.wednesdayEvenStartHrs}:{this.state.wednesdayEvenStartMin} to {this.state.wednesdayEvenEndHrs}:{this.state.wednesdayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.thursday == true ? <div>
							<div className="row">
								<p style={styleP}>Thursday Morning Time: </p>
								<p style={styleS}>{this.state.thursdayMornStartHrs}:{this.state.thursdayMornStartMin} to {this.state.thursdayMornEndHrs}:{this.state.thursdayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Thursday Evening Time:</p>
								<p style={styleS}>{this.state.thursdayEvenStartHrs}:{this.state.thursdayEvenStartMin} to {this.state.thursdayEvenEndHrs}:{this.state.thursdayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.friday == true ? <div>
							<div className="row">
								<p style={styleP}>Friday Morning Time: </p>
								<p style={styleS}>{this.state.fridayMornStartHrs}:{this.state.fridayMornStartMin} to {this.state.fridayMornEndHrs}:{this.state.fridayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Friday Evening Time:</p>
								<p style={styleS}>{this.state.fridayEvenStartHrs}:{this.state.fridayEvenStartMin} to {this.state.fridayEvenEndHrs}:{this.state.fridayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.saturday == true ? <div>
							<div className="row">
								<p style={styleP}>Saturday Morning Time: </p>
								<p style={styleS}>{this.state.saturdayMornStartHrs}:{this.state.saturdayMornStartMin} to {this.state.saturdayMornEndHrs}:{this.state.saturdayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Saturday Evening Time:</p>
								<p style={styleS}>{this.state.saturdayEvenStartHrs}:{this.state.saturdayEvenStartMin} to {this.state.saturdayEvenEndHrs}:{this.state.saturdayEvenEndMin}</p>
							</div></div> : ''}

						{this.props.viewClinicInfo.sunday == true ? <div>
							<div className="row">
								<p style={styleP}>Sunday Morning Time: </p>
								<p style={styleS}>{this.state.sundayMornStartHrs}:{this.state.sundayMornStartMin} to {this.state.sundayMornEndHrs}:{this.state.sundayMornEndMin}</p>
							</div>
							<div className="row">
								<p style={styleP}>Sunday Evening Time:</p>
								<p style={styleS}>{this.state.sundayEvenStartHrs}:{this.state.sundayEvenStartMin} to {this.state.sundayEvenEndHrs}:{this.state.sundayEvenEndMin}</p>
							</div></div> : ''} */}

					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		// signup: states.signin.userData
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ClinicDetail);

